module.exports = {"511126001":"青衣街道","511126002":"漹城街道","511126101":"黄土镇","511126102":"甘江镇","511126106":"吴场镇","511126107":"木城镇","511126108":"华头镇","511126110":"新场镇","511126111":"马村镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511126.json
// module id = 2466
// module chunks = 0